import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Latest band/score per community for chips and switcher dots. Redline staff get every scored
// community; company roles get their portfolio; pass companyId when a super admin views a portfolio.
export function usePulseBadge(companyId) {
  const [snaps, setSnaps] = useState({});
  const load = useCallback(() => {
    api.get(`/pulse/badge${companyId ? `?company_id=${companyId}` : ""}`).then((r) => setSnaps(r.data?.snapshots || {})).catch(() => {});
  }, [companyId]);
  useEffect(() => { load(); }, [load]);
  return [snaps, load];
}
